<template>
  <div class="home">
    <Header />
    <!-- <div class="open-container">
      <div class="content d-flex jc-between">
        <div class="left-wrap">
          <div class="title" @click="blockchain">
            {{ $t('home.header.title') }}
          </div>
          <div class="subtitle">{{ $t('home.header.subtitle') }}</div>
          <Button isHome />
        </div>
        <div class="keypal-wrap">
          <img class="keypal-3" src="../assets/images/home/keypal-3.png" />
          <img class="keypal-2" src="../assets/images/home/keypal-2.png" />
        </div>
        <Button isHome />
        <div class="open-bg-wrap">
          <img class="bg-1" src="../assets/images/home/open-bg-1.png" />
          <img class="bg-2" src="../assets/images/home/open-bg-2.png" />
          <img class="bg-3" src="../assets/images/home/open-bg-3.png" />
          <img class="light" src="../assets/images/home/light.png" />
        </div>
        <img class="bg-4" src="../assets/images/home/open-bg-4.png" />
      </div>
      <div class="mobile-open-bg-wrap">
        <img class="bg-1" src="../assets/images/home/open-bg-1.png" />
        <img class="bg-2" src="../assets/images/home/open-bg-2.png" />
        <img class="bg-3" src="../assets/images/home/open-bg-3.png" />
        <img class="bg-4" src="../assets/images/home/open-bg-4.png" />
        <img
          class="light-mobile"
          src="../assets/images/home/light-mobile.png"
        />
      </div>
    </div>
    <div class="linear-gradient"></div>
    <Introduce />
    <Function />
    <Software />
    <Specification /> -->
    <main>
      <VideoContent @playVideo="isShowVideo = true" />
      <KeyPal2Introduce @openVideo="openVideo" @goPosition="goViewPosition" />
      <Support />
      <FAQ />
    </main>
    <Footer />
    <div
      class="popup-video-fixed"
      v-if="popupVideoIndex"
      @click="popupVideoIndex = undefined"
    >
      <PopupVideoBox
        :class="{ ani: popupVideoIndex }"
        :index="popupVideoIndex"
        @close="popupVideoIndex = undefined"
      />
    </div>

    <div class="show-video-content" v-if="isShowVideo && (!isIos || !isMobileSize)">
      <video
        id="video"
        ref="showVideo"
        :src="showVideoUrl"
        autoplay
        muted
        x5-video-player-fullscreen="true"
        x5-video-player-type="h5"
        webkit-playsinline="true"
        playsinline="true"
        controls
      ></video>
      <img class="close-icon" :src="closeIcon" @click="isShowVideo = false" alt="" />
    </div>
    <!-- ios 移动端端直接播放全屏 -->
    <video
      v-if="isShowVideo && isIos && isMobileSize"
      id="video"
      ref="showVideo"
      :src="showVideoUrl"
      autoplay
      muted
      x5-video-player-fullscreen="true"
      x5-video-player-type="h5"
      webkit-playsinline="true"
      controls
    ></video>
  </div>
</template>

<script>
import Header from '../components/common/Header.vue';
import Introduce from '../components/home/Introduce.vue';
import Function from '../components/home/Function.vue';
import Software from '../components/home/Software.vue';
import Specification from '../components/home/Specification.vue';
import Footer from '../components/common/Footer.vue';
import Button from '../components/common/Button.vue';
import VideoContent from '../components/home/VideoContent.vue';
import KeyPal2Introduce from '../components/home/KeyPal2Introduce.vue';
import Support from '../components/home/Support.vue';
import FAQ from '../components/home/FAQ.vue';
import PopupVideoBox from '../components/home/PopupVideoBox.vue';

import buyLink from '../mixins/buyLink';
import { mapGetters } from 'vuex';
import { setMode } from '../utils';
import platform from '../utils/platform';
import Overlay from '../utils/overlay';
import ScrollLock from '../utils/scrollLock';

export default {
  name: 'Home',
  components: {
    Header,
    Introduce,
    Function,
    Software,
    Specification,
    Footer,
    Button,
    VideoContent,
    KeyPal2Introduce,
    Support,
    FAQ,
    PopupVideoBox,
  },
  mixins: [buyLink],
  data() {
    return {
      isPopupVideo: false,
      popupVideoIndex: undefined,
      overlay: null,
      isShowVideo: false,
      isIos: platform.isIos,
    };
  },

  mounted() {
  },
  computed: {
    ...mapGetters(['isMobileSize', 'isDarkMode']),
    showVideoUrl() {
      return `https://hk.tpstatic.net/keypal-2/${this.$i18n.locale}.mp4?version=2`;
    },
    closeIcon() {
      if (this.isDarkMode) {
        return require(`../assets/images/keypal-two/close-dark.png`);
      }
      return require(`../assets/images/keypal-two/close-1.png`);
    },
  },
  watch: {
    isShowVideo(val) {
      if (val) {
        // ScrollLock.lock();
        document.body.style.overflow = 'hidden';
        this.$nextTick(() => {
          const video = this.$refs.showVideo;
          if (!video) {
            return;
          }
          video.muted = false;
          // ios 监听视频进入全屏
          // video.addEventListener("webkitbeginfullscreen", () => {
          //   console.log("视频进入全屏");
          //   this.isShowVideo = false; 
          // });
          // // ios 监听视频退出全屏
          video.addEventListener("webkitendfullscreen", () => {
            console.log("视频退出全屏");
            this.isShowVideo = false; 
          });
        });
      } else {
        // ScrollLock.unlock();
        document.body.style.overflow = '';
      }
    },
    popupVideoIndex(val) {
      if (!val && this.isMobileSize) {
        const popup = document.querySelector('.popup-video');
        if (!popup) {
          return;
        }
        // popup.style.opacity = '0';
      }
      if (!val && !this.isMobileSize) {
        this.overlay.hide();
        ScrollLock.unlock();
      }
    },
  },
  methods: {
    blockchain() {
      // this.$router.push({
      //   path: '/firmwareupgrade',
      // })
    },
    openVideo(index) {
      this.popupVideoIndex = index;
      this.$nextTick(() => {
        if (this.isMobileSize) {
          const popup = document.querySelector('.popup-video');
          if (!popup) {
            return
          }
          if (!popup) {
            return
          }
          setTimeout(() => {
            popup.style.opacity = '1';
            popup.style.transition = 'opacity 0.3s';
          }, 10);
        }
      })
    },

    goViewPosition(selector) {
      // this.overlay = Overlay.create({ opacity: 0.3, duration: 200 });
      // this.overlay.show();
      // ScrollLock.lock();
      const selectorNode = this.$el.querySelector(selector);
      if (selectorNode) {
        // window.scrollTo({
        //   top: selectorNode.offsetTop - 70,
        //   behavior: 'smooth',
        // });
        selectorNode.scrollIntoView({
          behavior: 'smooth',
          block: 'center',     // 垂直方向居中
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  .open-container {
    padding: 0.6rem 0 1.7rem;
    background: #fbfdff;

    position: relative;
    .content {
      position: relative;
      padding-left: 0.2rem;
      .left-wrap {
        position: relative;
        z-index: 20;
        .title {
          max-width: 4.52rem;
          font-size: 0.44rem;
          line-height: 0.62rem;
          text-align: left;
        }
        .subtitle {
          margin-top: 0.3rem;
          max-width: 3.17rem;
          font-size: 0.22rem;
          line-height: 0.26rem;
          text-align: left;
        }
        .button {
          display: flex;
          // margin-top: 2rem;
          // margin-left: 1rem;
        }
      }
      .keypal-wrap {
        z-index: 10;
        .keypal-2 {
          width: 3.2rem;
          transform: translate(-1rem, -0.8rem);
        }
        .keypal-3 {
          width: 3.54rem;
          transform: translate(-0.25rem, 0.65rem);
        }
      }
      .button-mobile {
        display: none;
      }
      .open-bg-wrap {
        overflow: hidden;
        width: -webkit-fill-available;
        height: 7.76rem;
        position: absolute;
        top: 0;

        .bg-1 {
          position: absolute;
          max-width: 10.34rem;
          top: -0.2rem;
          left: 3rem;
        }
        .bg-2 {
          position: absolute;
          left: 3rem;
          top: 4.5rem;
          width: 0.99rem;
        }
        .bg-3 {
          position: absolute;
          right: 0.1rem;
          width: 1.01rem;
        }
        .light {
          position: absolute;
          max-width: 15.42rem;
          top: 0;
          left: 0;
          z-index: 11;
          opacity: 0.6;
        }
      }
      .bg-4 {
        position: absolute;
        width: 1.17rem;
        top: -0.8rem;
        left: -0.7rem;
      }
    }
    .mobile-open-bg-wrap {
      display: none;
    }
  }
  .linear-gradient {
    width: 100%;
    height: 0.6rem;
    background: linear-gradient(180deg, rgba(251, 253, 255, 0), #fbfdff);
    background: linear-gradient(#fbfdff, rgba(251, 253, 255, 0));
  }

  main {
    padding-top: 60px;
  }

  .popup-video-fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .show-video-content {
    position: fixed;
    top: 0;
    background: var(--bg-1);
    width: 100%;
    height: 100vh;
    z-index: 10001;
    display: flex;
    align-items: center;
    justify-content: center;

    #video {
      display: block;
      width: 1100px;
      height: 618px;
    }

    .close-icon {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 40px;
      height: 40px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 1200px) {
  .home {
    .show-video-content {
      #video {
        width: 90%;
        height: auto;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .home {
    .open-container {
      padding: 0.3rem 0 1.5rem 0;
      .content {
        padding: 0 0.32rem;
        flex-direction: column;
        .left-wrap {
          .title {
            padding: 0 0.5rem;
            font-size: 0.52rem;
            line-height: 0.8rem;
            max-width: none;
            text-align: center;
          }
          .subtitle {
            max-width: none;
            padding: 0 0.7rem;
            margin: 0;
            margin-top: 0.2rem;
            font-size: 0.32rem;
            text-align: center;
            line-height: 0.44rem;
          }
          .button {
            display: none;
          }
        }
        .keypal-wrap {
          margin-top: 1.5rem;
          .keypal-2 {
            transform: translate(-0.3rem, -0.8rem);
          }
          .keypal-3 {
            transform: translate(0.5rem, 0.65rem);
          }
        }
        .button-mobile {
          display: flex;
          margin-top: 1rem;
        }
        .open-bg-wrap {
          display: none;
        }
      }
      .mobile-open-bg-wrap {
        pointer-events: none;
        overflow: hidden;
        display: block;
        position: absolute;
        width: 100%;
        height: 15rem;
        top: 0;
        .bg-1 {
          position: absolute;
          width: 100%;
          top: 4.6rem;
          left: 0.7rem;
        }
        .bg-2 {
          position: absolute;
          width: 0.99rem;
          top: 8rem;
          left: 0.2rem;
        }
        .bg-3 {
          position: absolute;
          width: 1.01rem;
          right: 0;
          top: 3.7rem;
        }
        .bg-4 {
          display: none;
          position: absolute;
          width: 1.01rem;
        }
        .light-mobile {
          position: absolute;
          width: 100%;
          top: 4.3rem;
          z-index: 99;
          opacity: 0.6;
        }
      }
    }

    .popup-video-fixed {
      .popup-video {
        opacity: 0;
        transition: opacity 0.3s;
      }
    }

    .show-video-content {
      #video {
        width: 90%;
        height: auto;
      }
    }
  }
}
</style>
